import React from "react";

export const MagnifierIcon = ({ ...props }) => (
  <svg
    viewBox="0 0 50 50"
    width="20px"
    height="20px"
    { ...props }
  >
    <circle
      fill="none"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      cx="21"
      cy="20"
      r="16"
    />
    <line
      fill="none"
      stroke="#000000"
      strokeWidth="4"
      strokeMiterlimit="10"
      x1="32.229"
      y1="32.229"
      x2="45.5"
      y2="45.5"
    />
  </svg>
);

export default MagnifierIcon;
